import React from 'react';
import { Helmet } from 'react-helmet';
import AcademyHeroImage from '../../images/AcademyPage/HH25_Academy_HeroBackground.png';

const AcademyPage = () => {
  return (
    <div className="academy-page-container">
      <Helmet>
        <title>HappyHome - Academia HH</title>
        <meta name="description" content="" />
        <meta name="keywords" content="" />
        <meta property="og:title" content="HappyHome - Academia HH" />
        <meta property="og:description" content="" />
        <meta property="og:image" content={AcademyHeroImage} />
        <meta property="og:url" content="http://www.happyhome.com.ar" />
      </Helmet>
      <div className="academy-hero-section">
        <div className="academy-hero-bg-image">
          <img src={AcademyHeroImage} alt="Academia HappyHome Hero" />
          <div className="container-max-width">
            <h1 className="academy-hero-title">
              <span className="academy-hero-title-main">Academia <span className="academy-hero-title-hh">HappyHome<sup className="academy-hero-title-reg">®</sup></span></span>
              <span className="academy-hero-title-underline" />
            </h1>
            <div className="academy-hero-desc">
              <span className="academy-hero-desc-highlight">Un espacio pensado para que <span className="italic">sigas creciendo.</span></span><br />
              Capacitaciones diseñadas<br />
              para mejorar tus oportunidades laborales,<br />
              incorporar herramientas valiosas y fortalecer<br />
              los vínculos tanto en <span className="italic">el hogar</span> como en <span className="italic">el trabajo</span>.<br /><br />
              Cocina, limpieza, nutrición, cuidados,<br />
              bienestar emocional, mascotas, comunicación<br />
              y como desarrollarte en lo laboral...<br /><br />
              <span className="academy-hero-desc-bottom">Saberes cotidianos que mejoran nuestra<br />forma de vivir, cuidar y acompañar.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcademyPage;